export default __webpack_public_path__ + "static/media/search.c59081e2.svg";